const flaggedContentNL = {
    "view": {
        "form": {
            "button": {
                "viewDetails": "Bekijk Details"
            },
            "message": {
                "releaseHasBeenAddedToWhitelist": "Release <strong>{{releaseName}}</strong> is aan de whitelist toegevoegd.",
                "releaseHasFlaggedContent": "Release <strong>{{releaseName}}</strong> bevat gemarkeerde tracks. Er geldt een vergoeding van <strong>15 €</strong> per gemarkeerde track om het naar <strong>Spotify</strong> te leveren.<br/><br/> Klik op de onderstaande knop om uw betaling te voltooien en door te gaan."
            },
            "modal": {
                "header": {
                    "titleFlaggedTracksDetails": "Details van Gemarkeerde Tracks",
                    "titleFlaggedTrackPayment": "Spotify Whitelisting Betaling"
                },
                "body": {
                    "table": {
                        "title": "De volgende tracks zijn gemarkeerd. Bekijk de details hieronder:",
                        "column": {
                            "name": "Tracknaam",
                            "flaggedArtist": "Gemarkeerde Artiest",
                            "payableAmount": "Te Betalen Bedrag",
                            "paymentStatus": "Betaalstatus"
                        },
                        "label": {
                            "payableAmount": "15 €",
                            "paid": "BETAALD",
                            "pending": "IN AFWACHTING",
                        },
                    },
                    "label": {
                        "processingPayment": "Betaling Verwerken...",
                        "paymentSuccessful": "Betaling Succesvol!",
                        "paymentFailed": "Betaling Mislukt!"
                    },
                    "message": {
                        "totalPayableAmount": "Om de levering van uw release naar <strong>Spotify</strong> te voltooien, is een terugbetaalbare borg van <strong>{{totalAmount}} €</strong> vereist. Accepteer de onderstaande voorwaarden en klik op de knop <strong>Doorgaan</strong> om uw betaling te doen.",
                        "escrowAmountAgreement": "Ik accepteer en erken dat een borgbedrag van <strong>{{totalAmount}} €</strong> door mij zal worden gestort. Dit bedrag wordt vastgehouden tot het <strong>einde van het abonnement</strong> en, mits er geen problemen optreden, zal het aan het einde van deze periode aan mij worden terugbetaald. Echter, als ik tijdens deze periode de voorwaarden van deze overeenkomst schend, zal het borgbedrag worden toegepast op de openstaande factuur en niet worden terugbetaald. Door door te gaan, bevestig ik mijn begrip en acceptatie van deze voorwaarden.",
                        "escrowPaymentRejected": "Ik accepteer de voorwaarden van de borgbetaling niet en erken daarom dat mijn release <strong>{{releaseName}}</strong> <strong>niet naar Spotify zal worden gedistribueerd</strong>.",
                        "consentRecordedSuccessfully": "Toestemming Succesvol Opgenomen!"
                    }
                },
                "button": {
                    "proceed": "Doorgaan"
                }
            }
        }
    }
}

export default flaggedContentNL;